import axios from 'axios';
import { getApiUrl } from '../../../config';

export function requestGetGroup(groupId) {
    return axios.request({
        method: "get",
        url: getApiUrl() + "/group/" + groupId,
        withCredentials: true,
        crossorigin: true
    });
}

export function requestGetGroups(start, limit, state) {
    return axios.request({
        method: "get",
        url: getApiUrl() + "/group/",
        params: { start, limit, state },
        withCredentials: true,
        crossorigin: true,
    });
}

export function requestGetGroupBillingEntities() {
    return axios.request({
        method: "get",
        url: getApiUrl() + "/group/billingEntities",
        withCredentials: true,
        crossorigin: true,
    });
}

export function requestUpdateGroup(groupId, groupData) {
    return axios.request({
        method: "put",
        url: getApiUrl() + "/group/" + groupId,
        data: groupData,
        withCredentials: true,
        crossorigin: true,
    });
}

export function requestCreateGroup(groupData) {
    return axios.request({
        method: "post",
        url: getApiUrl() + "/group",
        data: groupData,
        withCredentials: true,
        crossorigin: true,
    });
}

export function requestCompleteGroup(groupId, options) {
    return axios.request({
        method: "put",
        url: getApiUrl() + "/group/" + groupId + "/complete",
        data: options || {},
        withCredentials: true,
        crossorigin: true,
    });
}

export function requestAddProjectToGroup(groupId, projectId) {
    return axios.request({
        method: "put",
        url: getApiUrl() + "/group/" + groupId + "/project",
        data: { projectId },
        withCredentials: true,
        crossorigin: true,
    });
}

export function requestRemoveProjectFromGroup(groupId, projectId) {

    return axios.request({
        method: "delete",
        url: getApiUrl() + "/group/" + groupId + "/project",
        data: { projectId },
        withCredentials: true,
        crossorigin: true,
    });
}

export function requestDeleteGroup(groupId) {
    return axios.request({
        method: "delete",
        url: getApiUrl() + "/group/" + groupId,
        withCredentials: true,
        crossorigin: true,
    });
}

export function requestRestoreGroup(groupId) {
    return axios.request({
        method: "put",
        url: getApiUrl() + "/group/" + groupId + "/restore",
        withCredentials: true,
        crossorigin: true,
    });
}